export { BvlInputComponent as BvlInput } from './input.component';
export { BvlInputModule } from './input.module';
